"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookieValue = void 0;
const getCookies_1 = require("./getCookies");
const getCookieValue = (cookieName) => {
    const cookies = (0, getCookies_1.getCookies)();
    const match = cookies.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`);
    return match ? match.pop() : '';
};
exports.getCookieValue = getCookieValue;
